module.exports = __webpack_public_path__ + "img/QA.f4d306e.png";